module.exports = __webpack_public_path__ + "img/no-exam-data.da6c049d.png";